import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { ProfileTabComponent } from './profile-tab/profile-tab.component';
import { SecurityTabComponent } from './security-tab/security-tab.component';
import { NotificationTabComponent } from './notification-tab/notification-tab.component';
import { TabsComponent } from '../../../../ui-components/lib/tabs/tabs.component';
import { TabComponent } from '../../../../ui-components/lib/tabs/tab/tab.component';
import { FeatureFlagsService } from '../../../common/services/feature-flags/feature-flags.service';
import { DelegationTabComponent } from './delegation-tab/delegation-tab.component';
import { FEATURE_FLAGS } from '../../../common/constants/feature-flags.constants';
import {
  injectSystemTabsLayout,
  injectFloatingLayout,
  provideSystemTabsLayout,
  injectFloatingPageClasses,
} from '../../../common/helpers/system-tabs-layout/system-tabs-layout';
import { ACCOUNT_SETTINGS_TABS } from './account-settings-tabs';

@Component({
  selector: 'lib-account-settings',
  imports: [
    NgComponentOutlet,
    NgTemplateOutlet,
    TranslocoPipe,
    ProfileTabComponent,
    TabsComponent,
    TabComponent,
    SecurityTabComponent,
    NotificationTabComponent,
    DelegationTabComponent,
  ],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.scss',
  providers: [provideSystemTabsLayout()],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccountSettingsComponent {
  private readonly featureFlags = inject(FeatureFlagsService);
  protected readonly systemTabs = injectSystemTabsLayout();
  protected readonly floating = injectFloatingLayout();
  protected readonly systemTabsPageClasses = injectFloatingPageClasses();
  protected readonly appTabs = inject(ACCOUNT_SETTINGS_TABS);
  protected readonly tabPanelClasses = computed(() =>
    this.floating() ? 'block floating-card p-2xl' : ''
  );

  isDelegationTabEnabled = computed(() =>
    this.featureFlags.getFeatureFlagValue(
      FEATURE_FLAGS.ACCOUNT_SETTINGS.delegation_tab
    )
  );
}
